import { CSSProperties } from 'react';

import styles from './styles.module.css';

interface SkeletonProps {
  height: CSSProperties['height'];
  width?: CSSProperties['width'];
}

const Skeleton: React.FC<SkeletonProps> = ({ height = '16px', width = '100%' }) => {
  return <div className={styles.skeleton} style={{ height, width }} />;
};

export { Skeleton };
